import { render, staticRenderFns } from "./WalmartShowPreview.vue?vue&type=template&id=6e5e3f38"
import script from "./WalmartShowPreview.vue?vue&type=script&lang=js"
export * from "./WalmartShowPreview.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/appdata/www/radzs_diego/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6e5e3f38')) {
      api.createRecord('6e5e3f38', component.options)
    } else {
      api.reload('6e5e3f38', component.options)
    }
    module.hot.accept("./WalmartShowPreview.vue?vue&type=template&id=6e5e3f38", function () {
      api.rerender('6e5e3f38', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/frontend/components/walmart/WalmartShowPreview.vue"
export default component.exports